import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import VisibilitySensor from 'react-visibility-sensor';
import { propBool, propFunc, propShape, } from '../../../../../helpers/custom-prop-types';
const SearchFilterSubmit = (props) => {
    const { isPositionAbsoluteSubmit, onChangeSubmit, onChangeVisibleSubmitButton, sensorRef, } = props;
    return (_jsxs("div", Object.assign({ className: 'search_list_filter_submit_box', ref: sensorRef }, { children: [_jsx(VisibilitySensor, Object.assign({ intervalDelay: 10, onChange: onChangeVisibleSubmitButton }, { children: _jsx("div", { className: 'search_list_filter_sensor' }) })), _jsx("div", Object.assign({ className: `search_list_filter_submit_row ${isPositionAbsoluteSubmit ? 'is-position-absolute' : ''}` }, { children: _jsx("button", Object.assign({ className: 'search_list_filter_submit', onClick: onChangeSubmit, type: 'button' }, { children: "\u7D5E\u308A\u8FBC\u307F" })) }))] })));
};
SearchFilterSubmit.propTypes = {
    isPositionAbsoluteSubmit: propBool().isRequired,
    onChangeSubmit: propFunc().isRequired,
    onChangeVisibleSubmitButton: propFunc().isRequired,
    sensorRef: propShape().isRequired,
};
export default SearchFilterSubmit;
